import { Component, OnInit } from '@angular/core';
import { DashboardStore } from './dashboard.store';
import { TranslateService } from '@ngx-translate/core';
import { CommonDialogService } from '@services/common-dialog.service';
const writtenNumber = require('written-number');

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [DashboardStore]
})
export class DashboardComponent implements OnInit {
  constructor(
    public store: DashboardStore,
    private translateService: TranslateService,
    public commonDialogService: CommonDialogService
  ) {}

  ngOnInit() {
    this.store.init();
  }

  numberWords(number: number) {
    return {
      number: number,
      numberWords: writtenNumber(number, {
        lang: this.translateService.currentLang.split('-')[0]
      })
    };
  }
}
